// Best-effort tool name → entry URL. Used by Workflow Builder v2 when the user
// clicks "Run in {Tool}" on a prompt artifact: we copy the prompt and open this
// URL in a new tab so they can paste and run.

const TOOL_URLS: Array<{ pattern: RegExp; url: string }> = [
  { pattern: /claude\s*code/i, url: 'https://claude.com/product/claude-code' },
  { pattern: /cursor/i, url: 'https://www.cursor.com/' },
  { pattern: /claude/i, url: 'https://claude.ai/new' },
  { pattern: /chatgpt|gpt-?\d|openai/i, url: 'https://chat.openai.com/' },
  { pattern: /gemini/i, url: 'https://gemini.google.com/app' },
  { pattern: /perplexity/i, url: 'https://www.perplexity.ai/' },
  { pattern: /notebooklm/i, url: 'https://notebooklm.google.com/' },
  { pattern: /midjourney/i, url: 'https://www.midjourney.com/' },
  { pattern: /gpt\s*image/i, url: 'https://chat.openai.com/' },
  { pattern: /ideogram/i, url: 'https://ideogram.ai/' },
  { pattern: /canva/i, url: 'https://www.canva.com/' },
  { pattern: /seedance|dreamina/i, url: 'https://www.capcut.com/' },
  { pattern: /veo/i, url: 'https://deepmind.google/technologies/veo/' },
  { pattern: /runway/i, url: 'https://runwayml.com/' },
  { pattern: /kling/i, url: 'https://klingai.com/' },
  { pattern: /synthesia/i, url: 'https://www.synthesia.io/' },
  { pattern: /surfer/i, url: 'https://surferseo.com/' },
  { pattern: /clearscope/i, url: 'https://www.clearscope.io/' },
  { pattern: /apollo/i, url: 'https://app.apollo.io/' },
  { pattern: /klaviyo/i, url: 'https://www.klaviyo.com/' },
  { pattern: /instantly/i, url: 'https://app.instantly.ai/' },
  { pattern: /sprout\s*social/i, url: 'https://app.sproutsocial.com/' },
  { pattern: /zapier/i, url: 'https://zapier.com/app/zaps' },
  { pattern: /salesforce\s*einstein|agentforce/i, url: 'https://www.salesforce.com/' },
  { pattern: /hubspot/i, url: 'https://app.hubspot.com/' },
  { pattern: /qwen/i, url: 'https://chat.qwen.ai/' },
  { pattern: /grok/i, url: 'https://x.ai/' },
  { pattern: /mistral/i, url: 'https://chat.mistral.ai/' },
  { pattern: /deepseek/i, url: 'https://chat.deepseek.com/' },
  { pattern: /granola/i, url: 'https://www.granola.ai/' },
  { pattern: /asana/i, url: 'https://app.asana.com/' },
  { pattern: /llama/i, url: 'https://www.llama.com/' },
  { pattern: /flux/i, url: 'https://bfl.ai/' },
  { pattern: /adobe\s*firefly|firefly/i, url: 'https://firefly.adobe.com/' },
];

export function getToolUrl(toolName: string | undefined): string | null {
  if (!toolName) return null;
  for (const { pattern, url } of TOOL_URLS) {
    if (pattern.test(toolName)) return url;
  }
  return null;
}
